
import { Component, Vue, Prop } from 'vue-property-decorator';

import StepCompletedCheckbox from './StepCompletedCheckbox.vue';
import TwoPageIcon from '@/iconSVG/TwoPageIcon.vue';
import SinglePageIcon from '@/iconSVG/SinglePageIcon.vue';
import DraftPageIcon from '@/iconSVG/DraftPageIcon.vue';
import ApprovedFormIcon from '@/iconSVG/ApprovedFormIcon.vue';
import TwoPageIconChecked from '@/iconSVG/TwoPageIconChecked.vue';

@Component({
    components:{
        StepCompletedCheckbox,
        TwoPageIcon,
        SinglePageIcon,
        DraftPageIcon,
        ApprovedFormIcon,
        TwoPageIconChecked
    }
})

export default class FormIcon extends Vue {


    @Prop({required: false})
    active!: boolean;
    
    @Prop({required: false})
    twoPages!: boolean;

    @Prop({required: false})
    status!: string;

    @Prop({required: false})
    stepTitleOptional!: string;

    @Prop({required: true})
    stepTitle!: string;  

    @Prop({required: false})
    ready!: boolean;

    @Prop({required: true})
    order!: number;    

    @Prop({required: false})
    stepTitleClass!: string;


    public action(){
        this.$emit('action')
    }
    public completed(checked) {
        this.$emit('completed', this.order-1, checked)
    }

}
